<evc-modal #modal [styles]="modalStyles">
    <span modal-title class="inspection-setup-modal__title">{{ modalTitle }}</span>

    <div modal-content>
        <div class="inspection-setup-modal__version" *ngIf="hasVersion">
            <span>Version : {{ version.version }}</span>
            <span>Last Update : {{ version.timestamp | date: 'MMMM d, y' }}</span>
        </div>

        <div class="inspection-setup-modal">
            <div class="inspection-setup-modal__card">
                <div class="inspection-setup-modal__card-header">
                    <span class="inspection-setup-modal__card-header-text">Inspection Library</span>
                </div>
                <div class="inspection-setup-modal__dropzone"
                     [class.dragover]="isDragOverWip"
                     (dragover)="onDragOver($event, 'wip')"
                     (dragleave)="onDragLeave($event, 'wip')"
                     (drop)="onDrop($event, 'wip')">
                    <evc-icon *ngIf="!hasFileWip"
                              class="inspection-setup-modal__icon"
                              file="file"
                              size="xl"></evc-icon>
                    <evc-icon *ngIf="hasFileWip"
                              class="inspection-setup-modal__icon inspection-setup-modal__icon--success"
                              icon="confirm-line"
                              size="xl"></evc-icon>
                    <p *ngIf="!hasFileWip" class="inspection-setup-modal__drop-text">Drop your file here or</p>
                    <p *ngIf="hasFileWip" class="inspection-setup-modal__file-name">{{ fileDisplayNameWip }}</p>
                    <input type="file" id="fileValueWip" (change)="handleFileUploadWip($event.target.files)">
                    <label class="inspection-setup-modal__browse" for="fileValueWip">
                        <span>{{ hasFileWip ? 'Replace' : 'Browse file' }}</span>
                        <evc-icon class="inspection-setup-modal__browse-icon"
                                  icon="download"
                                  size="sm"></evc-icon>
                    </label>
                </div>
            </div>

            <div class="inspection-setup-modal__card">
                <div class="inspection-setup-modal__card-header">
                    <span class="inspection-setup-modal__card-header-text">Lookup Table</span>
                </div>
                <div class="inspection-setup-modal__dropzone"
                     [class.dragover]="isDragOverGSN"
                     (dragover)="onDragOver($event, 'gsn')"
                     (dragleave)="onDragLeave($event, 'gsn')"
                     (drop)="onDrop($event, 'gsn')">
                    <evc-icon *ngIf="!hasFileGSN"
                              class="inspection-setup-modal__icon"
                              file="file"
                              size="xl"></evc-icon>
                    <evc-icon *ngIf="hasFileGSN"
                              class="inspection-setup-modal__icon inspection-setup-modal__icon--success"
                              icon="confirm-line"
                              size="xl"></evc-icon>
                    <p *ngIf="!hasFileGSN" class="inspection-setup-modal__drop-text">Drop your file here or</p>
                    <p *ngIf="hasFileGSN" class="inspection-setup-modal__file-name">{{ fileDisplayNameGSN }}</p>
                    <input type="file" id="fileValueGSN" (change)="handleFileUploadGSN($event.target.files)">
                    <label class="inspection-setup-modal__browse" for="fileValueGSN">
                        <span>{{ hasFileGSN ? 'Replace' : 'Browse file' }}</span>
                        <evc-icon class="inspection-setup-modal__browse-icon"
                                  icon="download"
                                  size="sm"></evc-icon>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <evc-button modal-actions type="primary" [disabled]="!canSave" (click)="confirm()">Save changes</evc-button>
    <evc-button modal-actions type="neutral" frame="ghost" (click)="cancel()">Cancel</evc-button>
</evc-modal>